import styled, { css } from "styled-components";
//import {  HashLink as Link } from "react-router-hash-link";
const {HashLink: Link} = require("react-router-hash-link");
// const rHashLink = require("react-router-hash-link");
// const {HashLink} = rHashLink
// const Link = HashLink

export const HeaderSection = styled("header")<{ $hidden?: boolean }>`
  padding: 1rem 0.5rem;
  position: sticky;
  top: 0;
  z-index: 100; 
  width: 100%;
  background-color: rgba(20.0,10.0,40.0,1.0);
  transition: transform 0.3s ease, opacity 0.3s ease;

  .ant-row-space-between {
    align-items: center;
    text-align: center;    
  }
  .site-layout-background {
    background: #fff;
  }

  @media only screen and (max-width: 890px) {
    transform: ${({ $hidden }) => ($hidden ? "translateY(-130%)" : "translateY(0)")};
    opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
    pointer-events: ${({ $hidden }) => ($hidden ? "none" : "auto")};
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const ContactWrapper = styled("div")<any>`
  cursor: pointer;
  width: ${(p) => (p.width ? "100%" : "110px")};
  font-weight: 700;
  text-align: center;
  border-radius: 1.25rem;
  display: inline-block;
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.1rem;
  color: rgba(255.0,255.0,255.0,1.0);
  transition: color 0.2s ease-in;
  white-space: nowrap;
  display: block;

  @media only screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const NavFlexContainer = styled("nav")`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem 1.5rem;

  @media only screen and (min-width: 1200px) {
    gap: 0.5rem 2rem;
  }

  @media only screen and (max-width: 1100px) {
    gap: 0.4rem 1rem;
  }

  @media only screen and (max-width: 992px) {
    gap: 0.3rem 0.75rem;
  }
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

export const PatreonButon =  styled("div")`
display: flex;
justify-content: space-between;
text-align: right;
align-items: right;
max-width: 510px;
width: 100%;
transition: all 0.1s ease-in-out;

a {
  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
  }
}

@media screen and (max-width: 769px) {
  width: auto;

  a:not(:last-child) {
    display: none;
  }
}

div {
  cursor: pointer;
  margin-right: 15px;
  width: 25px;
  height: 25px;

  &:hover {
    fill: rgb(255, 130, 92);
  }
}

body {
  text-align: right;
}
`;

export const MobileMenuWrapper = styled("div")`
  display: none;
  width: 100%;

  @media only screen and (max-width: 890px) {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
  }
`;

const mobileNavButtonStyles = css`
  display: block;
  width: 100%;
  padding: 0.45rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(60, 30, 90, 0.75);
  color: rgba(255, 255, 255, 1);
  font-size: 1.05rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;

  &:hover,
  &:focus {
    transform: translateY(-1px);
    border-color: rgba(255, 255, 255, 0.55);
    background: rgba(80, 45, 120, 0.85);
  }
`;

export const MobileNavButton = styled(Link)`
  ${mobileNavButtonStyles};
`;

export const MobileNavExternal = styled("a")`
  ${mobileNavButtonStyles};
`;

export const MobileSplitRow = styled("div")`
  display: flex;
  gap: 0.5rem;
  width: 100%;
`;

export const MobileSplitButton = styled(Link)`
  ${mobileNavButtonStyles};
  flex: 1;
  min-width: 0;
`;

export const ScrollTopButton = styled("button")`
  position: fixed;
  bottom: 0.65rem;
  right: 0.6rem;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(80, 45, 120, 0.92);
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.3s ease;
  z-index: 95;
  opacity: 0.95;

  &:hover,
  &:focus {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.75);
    outline-offset: 2px;
  }

  @media only screen and (min-width: 891px) {
    display: none;
  }
`;

export const RSSLink = styled("a")`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease, opacity 0.2s ease;
  opacity: 0.85;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover,
  &:focus {
    transform: scale(1.1);
    opacity: 1;
  }

  @media only screen and (max-width: 890px) {
    margin-top: 0.5rem;
    
    img {
      width: 22px;
      height: 22px;
    }
  }
`;

export const LogoAndRSSWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;

  @media only screen and (min-width: 891px) {
    flex-direction: row;
    gap: 0;
  }
`;

export const DesktopRSSWrapper = styled("div")`
  display: none;
  align-items: center;
  justify-content: flex-start;
  padding-left: 0.5rem;

  @media only screen and (min-width: 891px) {
    display: flex;
  }
`;

export const MobileRSSWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 891px) {
    display: none;
  }
`;